const offeringMarkets = [
  {
    offeringMarket: "P",
    offeringMarketDesc: "Primary"
  },
  {
    offeringMarket: "S",
    offeringMarketDesc: "Secondary"
  }
];

export const offeringMarketColumnDef = [
  {
    headerName: "Offering Market",
    field: "offeringMarket"
  },
  {
    headerName: "Description",
    field: "offeringMarketDesc"
  }
];

export default offeringMarkets;